import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import {DocumentLiquidation} from '../../model/Entities/DocumentLiquidation';
import {DocumentLiquidationService} from '../../services/documentLiquidation.service';
import {SnackService} from '../../services/snack.service';
import {Document} from '../../model/Entities/Document';
import {Filter} from '../../model/Helpers/Filter';
import {PohodaService} from '../../services/pohoda.service';
import {Customer} from '../../model/Entities/Customer';
import {Pohoda} from '../../model/Entities/Pohoda';

@Component({
    selector: 'document-pohoda-dialog',
    templateUrl: './document-pohoda.dialog.component.html',
    styleUrls: ['./document-pohoda.dialog.component.scss']
})
export class DocumentPohodaDialogComponent implements AfterViewInit {

    document: Document;
    sending = false;

    constructor(public dialog: MatDialogRef<DocumentPohodaDialogComponent>,
                private snackService: SnackService,
                private pohodaService: PohodaService,
                @Inject(MAT_DIALOG_DATA) public data: any) {

        this.document = data.document;


    }

    ngAfterViewInit(): void {

    }


    sendToPohoda() {
        this.sending = true;

        this.pohodaService.save(this.document).subscribe((p: Pohoda) => {
            this.sending = false;
            this.snackService.showSuccess('Dokument byl úspěšně zařazen k odeslání do Pohody.');
            this.dialog.close(true);
        }, (error) => {
            this.sending = false;
            console.log(error);
            this.snackService.showWarn('Při zařazování došlo k problému. ' + error.error.message);
        });
    }
}



// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentPohodaDialogComponent/document-pohoda.dialog.component.ts